import { useTranslation } from 'react-i18next';

import { ViewEmailCampaigns } from './ViewEmailCampaigns';
import { MainLayout } from 'layouts/MainLayout';
import { MainHeader } from 'features/common/components/MainHeader';

export const Marketing = () => {
	const { t } = useTranslation();

	return (
		<MainLayout>
			<MainHeader>
				<MainHeader.Title element="h1">{t('marketing-email-campaigns')}</MainHeader.Title>
			</MainHeader>
			<ViewEmailCampaigns />
		</MainLayout>
	);
};
